<template>
  <div class="banner">
    <div class="slidebanner">
      <div class="bd">
        <ul>
          <li>
            <a href="" style="background:url(./img/banner1.png) no-repeat top center"></a>
          </li>
        </ul>
      </div>
    </div>
    <div class="nb">
      <div class="nav">
        <div class="nav-classify">
          <ul class="menu-mainnav" style="height: 450px; display: block">
            <li v-for="(item, index) in homePageInfo.prodClasses" :key="index">
              <div class="sortmaintitle color-change">
                <a href="javascript:void(0);" @click="$emit('jumpToProductPage', item.hktId)">{{item.hktName}}</a>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="lognew">
        <div class="login-quick">
          <p>你好， <a v-if="userInfo.userId" href="javascript:void(0);" class="system-name">{{userInfo.name}}</a></p>
          <a v-if="!userInfo.userId" href="/login" class="btn-login">请登录</a>
          <a v-if="!userInfo.userId" href="/register" class="btn-regist">免费注册</a>
        </div>
        <div class="new-quick">
          <div class="quicknew-bar">
            <span>最新资讯</span>
          </div>
          <ul>
            <li v-for="(item, index) in homePageInfo.informations" :key="index">
              <a :href="`/information?infoId=${item.infoId}`" target="_blank">{{item.title}}</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeBanner',
  props: {
    homePageInfo: {
      type: Object,
      required: true
    },
    userInfo: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
.banner {
  position: relative;
  width: 100%;
}

.slidebanner {
  width: 100%;
  height: 450px;
}

.bd ul li a {
  display: block;
  width: 100%;
  height: 450px;
  background-size: cover !important;
}

.nav {
  position: absolute;
  left: 0;
  top: 0;
  width: 200px;
  height: 450px;
  background: rgba(0,0,0,0.6);
  z-index: 10;
}

.menu-mainnav {
  padding: 0;
  margin: 0;
  list-style: none;
}

.menu-mainnav li {
  padding: 0 15px;
  height: 45px;
  line-height: 45px;
  border-bottom: 1px solid #333;
}

.sortmaintitle a {
  color: #fff;
  text-decoration: none;
  font-size: 14px;
}

.lognew {
  position: absolute;
  right: 0;
  top: 0;
  width: 200px;
  height: 450px;
  background: #fff;
  z-index: 10;
  padding: 15px;
}

.login-quick {
  margin-bottom: 20px;
}

.btn-login, .btn-regist {
  display: inline-block;
  padding: 5px 10px;
  margin-right: 5px;
  background: #f60;
  color: #fff;
  text-decoration: none;
  border-radius: 3px;
}

.quicknew-bar {
  margin-bottom: 10px;
  font-weight: bold;
}

.new-quick ul {
  padding: 0;
  margin: 0;
  list-style: none;
}

.new-quick ul li {
  margin-bottom: 10px;
}

.new-quick ul li a {
  color: #666;
  text-decoration: none;
  font-size: 12px;
}
</style>